import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import moment from "moment-timezone";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { languages } from "../../constants/languages";
import { getResultSpotName } from "../../util/GetResultSpotName";
// import ExportScheduleDialog from "../../components/results/ExportScheduleDialog";
import IconButton from "@material-ui/core/IconButton";
import { jsPDF } from "jspdf";
import ReactExport from "react-export-excel";
import ExportDialog from "../../components/results/ExportDialog";
import defaultFases from "../../constants/DefaultFases";
import robotoBold from "../../constants/jsPdf/Roboto-Bold-bold";
import robotoMedium from "../../constants/jsPdf/Roboto-Medium-normal";
import { getGameResults } from "../../util/GetGameResults";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const styles = (theme) => ({
  button: {
    position: "absolute",
    right: 10,
    top: 65,
    [theme.breakpoints.down("xs")]: {
      top: 55,
    },
  },

  buttonSchedule: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  iconButton: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
});

class ExportContainer extends Component {
  state = {
    open: false,
    anchorEl: null,
    exportScheduleOpen: false,
    exportDialogOpen: false,
    fileType: "pdf",
    format: "multiple",
    sort: "time",
    // days: [],
    // divisions: [],
    fases: {},
    selectedLocation: "all",
    selectedDay: "all",
    export: "cards",
    includeEvents: false,
    includeResults: false,
    includePlayerNames: false,
    includeCustomFields: false,
    preparingExcelExport: false,
    exportExcel: false,
    cols: [],
    sheets: [],
  };

  handleIncludeEventsChange = () => {
    this.setState({ includeEvents: !this.state.includeEvents });
  };
  handleIncludePlayerNamesChange = () => {
    this.setState({ includePlayerNames: !this.state.includePlayerNames });
  };
  handleIncludeResultsChange = () => {
    this.setState({ includeResults: !this.state.includeResults });
  };
  handleIncludeCustomFieldsChange = () => {
    this.setState({ includeCustomFields: !this.state.includeCustomFields });
  };
  handleFileTypeChange = (e) => {
    this.setState({ fileType: e.target.value });
  };

  // handleSelectChange = (key, name) => {
  //   let newKeys = this.state[name];
  //   if (newKeys.indexOf(key) !== -1) {
  //     newKeys.splice(newKeys.indexOf(key), 1);
  //   } else {
  //     newKeys.push(key);
  //   }
  //   let toUpdate = {};
  //   toUpdate[name] = newKeys;
  //   this.setState(toUpdate);
  // };

  handleLocationChange = (event) => {
    let newState = { fases: {} };
    newState[event.target.name] = event.target.value;
    this.setState(newState);
  };

  handleFasesChange = (key, faseKey) => {
    let newState = this.state.fases;
    if (newState[key] === undefined) {
      newState[key] = [faseKey];
    } else {
      if (newState[key].indexOf(faseKey) !== -1) {
        newState[key].splice(newState[key].indexOf(faseKey), 1);
      } else {
        newState[key].push(faseKey);
      }
    }
    let toUpdate = {};
    toUpdate["fases"] = newState;
    this.setState(toUpdate);
  };

  selectAllPhases = () => {
    const newState = {};
    Object.keys(this.props.divisionsObject).forEach((key) => {
      let fases = this.props.divisionsObject[key].fases || defaultFases;

      Object.keys(fases).forEach((faseKey) => {
        let showFase = false;
        if (this.state.selectedLocation === "all") {
          showFase = true;
        } else {
          let poules = this.props.poules
            .filter((p) => p.fase.toString() === faseKey && p.division === key)
            .map((p) => p.id);
          let matches = this.props.matches.filter(
            (m) => poules.indexOf(m.poule) !== -1
          );
          let matchInSportPark = false;
          for (let i = 0; i < matches.length; i++) {
            let m = matches[i];
            let fields = this.props.tournament.fields || {};
            let field = fields[m.field];
            if (field) {
              let sportPark = field.sportPark || "0";
              if (this.props.selectedLocation === sportPark) {
                matchInSportPark = true;
                break;
              }
            }
          }
          if (matchInSportPark) {
            showFase = true;
          }
        }
        if (showFase) {
          if (newState[key] === undefined) {
            newState[key] = [faseKey];
          } else {
            if (newState[key].indexOf(faseKey) === -1) {
              newState[key].push(faseKey);
            }
          }
        }
      });
    });
    this.setState({ fases: newState });
  };

  toggleExportScheduleDialog = () => {
    this.setState({
      exportDialogOpen: !this.state.exportDialogOpen,
      export: "schedule",
      anchorEl: null,
      sort: "time",
    });
  };

  toggleExportDialog = () => {
    this.setState({
      exportDialogOpen: !this.state.exportDialogOpen,
      export: "cards",
      anchorEl: null,
    });
  };

  handleFormatChange = (event) => {
    this.setState({ format: event.target.value });
  };

  handleSortChange = (event) => {
    this.setState({ sort: event.target.value });
  };

  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleExcelExport = () => {
    let initialState = {
      exportExcel: false,
      preparingExcelExport: true,
      sheets: [],
      cols: [],
    };
    this.setState(initialState);

    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    tournamentRef
      .collection("teamsContactInfo")
      .onSnapshot((querySnapshotInfo) => {
        var info = {};
        querySnapshotInfo.forEach(function (doc) {
          info[doc.id] = doc.data();
        });
        tournamentRef
          .collection("teams")
          .orderBy("name")
          .get()
          .then((querySnapshot) => {
            let columns = [
              { id: "startTime", label: languages.schedule.startTime },
              {
                id: this.props.tournament.online ? "roundString" : "endTime",
                label: this.props.tournament.online
                  ? languages.schedule.round
                  : languages.schedule.endTime,
              },
            ];
            if (
              (Object.keys(this.props.matchesPerDay).length > 1 &&
                !this.props.tournament.online) ||
              (this.props.tournament.online &&
                Object.keys(this.props.daysByKey).length > 0)
            ) {
              columns.push({ id: "dayString", label: languages.schedule.day });
            }
            if (!this.props.tournament.online) {
              columns.push({
                id: "fieldString",
                label: languages.schedule.field,
              });
              if (this.props.sportParks.length > 1) {
                columns.push({
                  id: "locationString",
                  label: languages.schedule.sportPark,
                });
              }
            }
            columns.push({
              id: "phaseString",
              label: languages.structure.fase,
            });
            if (Object.keys(this.props.divisionsObject).length > 1) {
              columns.push({
                id: "divisionString",
                label: languages.divisions.division,
              });
            }
            columns.push({
              id: "pouleString",
              label: languages.structure.poule,
            });
            columns.push({
              id: "team1String",
              label:
                (this.props.tournament.individualPlayers
                  ? languages.teams.player
                  : languages.results.team) + " 1",
            });
            if (this.state.includeResults) {
              columns.push({
                id: "result1String",
                label:
                  languages.results.result +
                  " " +
                  (this.props.tournament.individualPlayers
                    ? languages.teams.playerLow
                    : languages.results.teamLow) +
                  " 1",
              });
            }

            if (this.state.includeResults) {
              Object.keys(this.props.tournament.customPoints || {}).forEach(
                (key, i) => {
                  let customPoints = this.props.tournament.customPoints[key];
                  columns.push({
                    id: "custom1" + key,
                    label:
                      customPoints.abbr +
                      " " +
                      (this.props.tournament.individualPlayers
                        ? languages.teams.playerLow
                        : languages.results.teamLow) +
                      " 1",
                  });
                }
              );
            }

            let matchesArray = [];
            let showReferee1Col = false;
            let showReferee2Col = false;
            let showReferee3Col = false;
            let showReferee4Col = false;
            let showReferee5Col = false;
            let numPlayerColumns = 0;
            let numSetColumns = 0;
            let showTimeColForOnline = false;

            let allTeams = [];
            let teamsByKey = {};
            querySnapshot.forEach((doc) => {
              let team = doc.data();
              team["id"] = doc.id;
              allTeams.push(team);
              teamsByKey[doc.id] = team;
            });

            Object.keys(
              this.props.tournament.online
                ? this.props.onlineRounds
                : this.props.matchesPerDay
            ).forEach((d) => {
              let matches = (
                this.props.tournament.online
                  ? this.props.onlineRounds
                  : this.props.matchesPerDay
              )[d];
              matches.forEach((m) => {
                let matchCopy = { ...m };
                let showPenaltiesInMatchButton = false;
                let score1PenaltyAsterisk = "";
                let score2PenaltyAsterisk = "";

                const poule = this.props.poulesByKey[m.poule] || {};
                let scoreType =
                  poule.scoreType ||
                  (poule.bracket
                    ? (this.props.bracketsByKey[poule.bracket] || {})[
                        "scoreType"
                      ]
                    : false) ||
                  ((this.props.tournament.scoringTypesPerDivisionPerPhase ||
                    {})[poule.division] || {})[poule.fase] ||
                  "default";
                let scoring =
                  scoreType === "default"
                    ? this.props.tournament
                    : (this.props.tournament.scoringTypes || {})[scoreType] ||
                      this.props.tournament;

                const useSets = (scoring.useSets || "0") === "1";
                const setsType = scoring.setsType || 0;

                if (m.score1 !== null && m.score2 !== null && !useSets) {
                  if (m.score1 > m.score2) {
                    score1PenaltyAsterisk = "*";
                  } else if (m.score1 < m.score2) {
                    score2PenaltyAsterisk = "*";
                  } else {
                    if (m.winner === m.team1) {
                      score1PenaltyAsterisk = "*";
                    } else if (m.winner === m.team2) {
                      score2PenaltyAsterisk = "*";
                    }
                    if (
                      scoring.enterPenaltyScores &&
                      m.penalties1 !== null &&
                      m.penalties1 !== undefined &&
                      m.penalties2 !== null &&
                      m.penalties2 !== undefined
                    ) {
                      showPenaltiesInMatchButton = true;
                    }
                  }
                }

                if (!useSets) {
                  matchCopy["result1String"] =
                    m.score1 !== null && m.score1 !== undefined
                      ? m.score1 +
                        (showPenaltiesInMatchButton
                          ? "(" + m.penalties1.toString() + ")"
                          : score1PenaltyAsterisk)
                      : "";
                  matchCopy["result2String"] =
                    m.score2 !== null && m.score2 !== undefined
                      ? m.score2 +
                        (showPenaltiesInMatchButton
                          ? "(" + m.penalties2.toString() + ")"
                          : score2PenaltyAsterisk)
                      : "";
                } else {
                  let gameResults = getGameResults(scoring, m.sets || {});
                  if (gameResults.finished) {
                    if (setsType === 0) {
                      if (gameResults.result1 !== null) {
                        matchCopy["result1String"] = gameResults.result1;
                      }
                      if (gameResults.result2 !== null) {
                        matchCopy["result2String"] = gameResults.result2;
                      }
                    }
                  }
                  const numSets = Object.keys(gameResults.sets).length;
                  if (numSets > numSetColumns) {
                    numSetColumns = numSets;
                  }
                  Object.keys(gameResults.sets).forEach((key, i) => {
                    let set = gameResults.sets[key];
                    if (set.score1 !== null) {
                      matchCopy["set" + (i + 1).toString() + "team1"] = Number(
                        set.score1
                      );
                    }
                    if (set.score2 !== null) {
                      matchCopy["set" + (i + 1).toString() + "team2"] = Number(
                        set.score2
                      );
                    }
                  });
                }

                Object.keys(this.props.tournament.customPoints || {}).forEach(
                  (key) => {
                    if ((m.extra1 || {})[key]) {
                      matchCopy["custom1" + key] = (m.extra1 || {})[key];
                    }

                    if ((m.extra2 || {})[key]) {
                      matchCopy["custom2" + key] = (m.extra2 || {})[key];
                    }
                  }
                );

                matchCopy["fieldString"] =
                  ((this.props.tournament.fields || {})[m.field] || {}).name ||
                  "";
                let fields = this.props.tournament.fields || {};
                let field = fields[m.field] || {};
                let sportPark = field.sportPark || "0";
                matchCopy["locationString"] =
                  (this.props.sportParksByKey[sportPark] || {}).name || "";

                if (this.props.tournament.online) {
                  let roundTime =
                    (this.props.tournament.roundTimes || {})[Number(d)] || {};
                  let time = roundTime["time"] || "";
                  if (time) {
                    showTimeColForOnline = true;
                  }

                  let day = roundTime["day"] || "0";
                  matchCopy["day"] = day;
                  let roundDate =
                    day === "0"
                      ? this.props.tournament.date
                      : (this.props.daysByKey[day] || {}).date || "";
                  if (roundDate) {
                    roundDate = moment
                      .unix(roundDate)
                      .format(languages.dateFormatRound);
                  }
                  if (Object.keys(this.props.daysByKey).length === 0) {
                    roundDate = "";
                  }
                  matchCopy["dayString"] = roundDate;
                  matchCopy["startTime"] = time;
                  matchCopy["roundString"] =
                    languages.schedule.round + " " + (Number(d) + 1).toString();
                } else {
                  matchCopy["dayString"] =
                    Object.keys(this.props.matchesPerDay).length > 1
                      ? m.day === "0"
                        ? moment
                            .unix(this.props.tournament.date)
                            .format(languages.createTournament.dateFormat)
                        : moment
                            .unix((this.props.daysByKey[m.day] || {}).date)
                            .format(languages.createTournament.dateFormat)
                      : "";
                }
                if (!this.props.tournament.online) {
                  const referee1Name =
                    (this.props.refereesByKey[m.referee] || {}).name || "";
                  matchCopy["referee1Name"] = referee1Name;
                  if (referee1Name) {
                    showReferee1Col = true;
                  }
                  const referee2Name =
                    (this.props.refereesByKey[m.referee2] || {}).name || "";
                  matchCopy["referee2Name"] = referee2Name;
                  if (referee1Name) {
                    showReferee2Col = true;
                  }
                  const referee3Name =
                    (this.props.refereesByKey[m.referee3] || {}).name || "";
                  matchCopy["referee3Name"] = referee3Name;
                  if (referee3Name) {
                    showReferee3Col = true;
                  }
                  const referee4Name =
                    (this.props.refereesByKey[m.referee4] || {}).name || "";
                  matchCopy["referee4Name"] = referee4Name;
                  if (referee4Name) {
                    showReferee4Col = true;
                  }
                  const referee5Name =
                    (this.props.refereesByKey[m.referee5] || {}).name || "";
                  matchCopy["referee5Name"] = referee5Name;
                  if (referee5Name) {
                    showReferee5Col = true;
                  }
                }

                matchCopy["pouleString"] = poule.name || "";
                matchCopy["divisionString"] =
                  (this.props.divisionsObject[poule.division] || {}).name || "";
                const fase = poule.fase;
                matchCopy["phaseString"] =
                  (
                    ((this.props.divisionsObject[poule.division] || {}).fases ||
                      {})[fase] || {}
                  ).name ||
                  (defaultFases[fase] || {}).name ||
                  "";

                let pouleKeyName = poule.fase;
                if (poule.bracket) {
                  let bracket = this.props.bracketsByKey[poule.bracket] || {};
                  pouleKeyName =
                    poule.bracketRound === bracket.size && !bracket.subBracketTo
                      ? poule.fase
                      : poule.fase +
                        "-" +
                        poule.bracketRound +
                        "-" +
                        poule.bracket;
                }
                const team1 = allTeams.find(
                  (t) =>
                    t["poule" + pouleKeyName] === m.poule &&
                    t["numInPoule" + pouleKeyName] === m.team1
                );
                if (team1 && !m.isEvent) {
                  matchCopy["team1Id"] = team1.id;
                  const players1 = this.props.players.filter(
                    (p) => p.team === team1.id
                  );
                  if (players1.length > numPlayerColumns) {
                    numPlayerColumns = players1.length;
                  }
                  players1
                    .sort((a, b) => {
                      if (a.name < b.name) {
                        return -1;
                      }
                      if (a.name > b.name) {
                        return 1;
                      }
                      return 0;
                    })
                    .forEach((p, i) => {
                      matchCopy[
                        languages.teams.player +
                          (i + 1).toString() +
                          (this.props.tournament.individualPlayers
                            ? languages.teams.playerLow
                            : languages.results.teamLow) +
                          "1"
                      ] = p.name || "";
                    });

                  Object.keys(this.props.tournament.infoFields || {}).forEach(
                    (key) => {
                      if ((info[team1.id] || {})[key] !== undefined) {
                        matchCopy[
                          key +
                            "i" +
                            (this.props.tournament.individualPlayers
                              ? languages.teams.playerLow
                              : languages.results.teamLow) +
                            "1"
                        ] = (info[team1.id] || {})[key];
                      }
                    }
                  );
                }
                let team1String = (team1 || {}).name || undefined;

                const team2 = allTeams.find(
                  (t) =>
                    t["poule" + pouleKeyName] === m.poule &&
                    t["numInPoule" + pouleKeyName] === m.team2
                );
                if (team2 && !m.isEvent) {
                  matchCopy["team2Id"] = team2.id;
                  const players2 = this.props.players.filter(
                    (p) => p.team === team2.id
                  );
                  if (players2.length > numPlayerColumns) {
                    numPlayerColumns = players2.length;
                  }
                  players2
                    .sort((a, b) => {
                      if (a.name < b.name) {
                        return -1;
                      }
                      if (a.name > b.name) {
                        return 1;
                      }
                      return 0;
                    })
                    .forEach((p, i) => {
                      matchCopy[
                        languages.teams.player +
                          (i + 1).toString() +
                          (this.props.tournament.individualPlayers
                            ? languages.teams.playerLow
                            : languages.results.teamLow) +
                          "2"
                      ] = p.name || "";
                    });
                  Object.keys(this.props.tournament.infoFields || {}).forEach(
                    (key) => {
                      if ((info[team2.id] || {})[key] !== undefined) {
                        matchCopy[
                          key +
                            "i" +
                            (this.props.tournament.individualPlayers
                              ? languages.teams.playerLow
                              : languages.results.teamLow) +
                            "2"
                        ] = (info[team2.id] || {})[key];
                      }
                    }
                  );
                }
                let team2String = (team2 || {}).name || undefined;
                if (team1String === undefined) {
                  team1String =
                    this.props.resultSpots.filter(
                      (resultSpot) =>
                        resultSpot["poule" + poule.fase] === m.poule &&
                        resultSpot["numInPoule" + poule.fase] === m.team1
                    )[0] || "";
                  if (team1String !== "") {
                    team1String = getResultSpotName(
                      team1String,
                      this.props.resultSpots,
                      this.props.poulesByKey,
                      this.props.divisionsObject
                    );
                  }
                }
                matchCopy["team1String"] = team1String;
                if (team2String === undefined) {
                  team2String =
                    this.props.resultSpots.filter(
                      (resultSpot) =>
                        resultSpot["poule" + poule.fase] === m.poule &&
                        resultSpot["numInPoule" + poule.fase] === m.team2
                    )[0] || "";
                  if (team2String !== "") {
                    team2String = getResultSpotName(
                      team2String,
                      this.props.resultSpots,
                      this.props.poulesByKey,
                      this.props.divisionsObject
                    );
                  }
                }
                matchCopy["team2String"] = team2String;

                if (m.isEvent) {
                  let teamStrings = [];
                  m.teams.forEach((t) => {
                    let teamObject = teamsByKey[t];
                    if (teamObject) {
                      teamStrings.push(teamObject.name || "");
                    }
                  });
                  matchCopy["team1String"] = teamStrings.join(", ");
                  matchCopy["pouleString"] = m.name || "";
                  matchCopy["team2String"] = "";
                }

                if (m.isEvent) {
                  if (this.state.includeEvents) {
                    matchesArray.push(matchCopy);
                  }
                } else {
                  matchesArray.push(matchCopy);
                }
              });
            });

            if (!this.props.tournament.online) {
              matchesArray = matchesArray.filter(
                (m) => m.day === "0" || this.props.daysByKey[m.day]
              );

              let fields = this.props.tournament.fields || {};

              matchesArray.sort((a, b) => {
                let dateA =
                  a.day === "0"
                    ? this.props.tournament.date
                    : this.props.daysByKey[a.day].date;
                let dateB =
                  b.day === "0"
                    ? this.props.tournament.date
                    : this.props.daysByKey[b.day].date;
                let fieldA = fields[a.field] || {};
                let fieldB = fields[b.field] || {};
                if (dateA > dateB) {
                  return 1;
                } else if (dateA < dateB) {
                  return -1;
                } else if (
                  moment(a.startTime, "HH:mm").unix() >
                  moment(b.startTime, "HH:mm").unix()
                ) {
                  return 1;
                } else if (
                  moment(a.startTime, "HH:mm").unix() <
                  moment(b.startTime, "HH:mm").unix()
                ) {
                  return -1;
                } else if (fieldA.num > fieldB.num) {
                  return 1;
                } else if (fieldA.num < fieldB.num) {
                  return -1;
                } else if (Number(a.field) > Number(b.field)) {
                  return 1;
                } else if (Number(a.field) < Number(b.field)) {
                  return -1;
                } else {
                  return 0;
                }
              });

              if (this.state.sort === "field") {
                matchesArray.sort((a, b) => {
                  let dateA =
                    a.day === "0"
                      ? this.props.tournament.date
                      : this.props.daysByKey[a.day].date;
                  let dateB =
                    b.day === "0"
                      ? this.props.tournament.date
                      : this.props.daysByKey[b.day].date;
                  let fieldA = fields[a.field] || {};
                  let fieldB = fields[b.field] || {};
                  if (dateA > dateB) {
                    return 1;
                  } else if (dateA < dateB) {
                    return -1;
                  } else if (fieldA.num > fieldB.num) {
                    return 1;
                  } else if (fieldA.num < fieldB.num) {
                    return -1;
                  } else if (Number(a.field) > Number(b.field)) {
                    return 1;
                  } else if (Number(a.field) < Number(b.field)) {
                    return -1;
                  } else if (
                    moment(a.startTime, "HH:mm").unix() >
                    moment(b.startTime, "HH:mm").unix()
                  ) {
                    return 1;
                  } else if (
                    moment(a.startTime, "HH:mm").unix() <
                    moment(b.startTime, "HH:mm").unix()
                  ) {
                    return -1;
                  } else {
                    return 0;
                  }
                });
              }
            }
            matchesArray = matchesArray.filter((match) => {
              let division =
                (this.props.poulesByKey[match.poule] || {}).division || "";
              let fase =
                (this.props.poulesByKey[match.poule] || {}).fase !== undefined
                  ? (this.props.poulesByKey[match.poule] || {}).fase
                  : "";

              let fields = this.props.tournament.fields || {};
              let field = fields[match.field] || {};
              let sportPark = field.sportPark || "0";

              if (
                ((this.state.fases[division] || []).indexOf(fase.toString()) !==
                  -1 ||
                  (match.isEvent && this.state.includeEvents)) &&
                (sportPark === this.state.selectedLocation ||
                  this.state.selectedLocation === "all") &&
                (match.day === this.state.selectedDay ||
                  this.state.selectedDay === "all")
              ) {
                return true;
              } else {
                return false;
              }
            });

            if (this.props.tournament.online && !showTimeColForOnline) {
              columns.shift();
            }

            if (this.state.includeResults) {
              for (let i = 0; i < numSetColumns; i++) {
                columns.push({
                  id: "set" + (i + 1).toString() + "team1",
                  label:
                    languages.results.set +
                    " " +
                    (i + 1).toString() +
                    " " +
                    (this.props.tournament.individualPlayers
                      ? languages.teams.playerLow
                      : languages.results.teamLow) +
                    " 1",
                });
              }
            }

            if (this.state.includeCustomFields) {
              Object.keys(this.props.tournament.infoFields || {}).forEach(
                (key) => {
                  let extraField = this.props.tournament.infoFields[key];
                  columns.push({
                    id:
                      key +
                      "i" +
                      (this.props.tournament.individualPlayers
                        ? languages.teams.playerLow
                        : languages.results.teamLow) +
                      "1",
                    label:
                      extraField.name +
                      " " +
                      (this.props.tournament.individualPlayers
                        ? languages.teams.playerLow
                        : languages.results.teamLow) +
                      " 1",
                  });
                }
              );
            }

            if (this.state.includePlayerNames) {
              for (let i = 0; i < numPlayerColumns; i++) {
                columns.push({
                  id:
                    languages.teams.player +
                    (i + 1).toString() +
                    (this.props.tournament.individualPlayers
                      ? languages.teams.playerLow
                      : languages.results.teamLow) +
                    "1",
                  label:
                    languages.teams.player +
                    " " +
                    (i + 1).toString() +
                    " " +
                    (this.props.tournament.individualPlayers
                      ? languages.teams.playerLow
                      : languages.results.teamLow) +
                    " 1",
                });
              }
            }
            columns.push({
              id: "team2String",
              label:
                (this.props.tournament.individualPlayers
                  ? languages.teams.player
                  : languages.results.team) + " 2",
            });
            if (this.state.includeResults) {
              columns.push({
                id: "result2String",
                label:
                  languages.results.result +
                  " " +
                  (this.props.tournament.individualPlayers
                    ? languages.teams.playerLow
                    : languages.results.teamLow) +
                  " 2",
              });
            }

            if (this.state.includeResults) {
              Object.keys(this.props.tournament.customPoints || {}).forEach(
                (key, i) => {
                  let customPoints = this.props.tournament.customPoints[key];
                  columns.push({
                    id: "custom2" + key,
                    label:
                      customPoints.abbr +
                      " " +
                      (this.props.tournament.individualPlayers
                        ? languages.teams.playerLow
                        : languages.results.teamLow) +
                      " 2",
                  });
                }
              );
            }

            if (this.state.includeResults) {
              for (let i = 0; i < numSetColumns; i++) {
                columns.push({
                  id: "set" + (i + 1).toString() + "team2",
                  label:
                    languages.results.set +
                    " " +
                    (i + 1).toString() +
                    " " +
                    (this.props.tournament.individualPlayers
                      ? languages.teams.playerLow
                      : languages.results.teamLow) +
                    " 2",
                });
              }
            }

            if (this.state.includeCustomFields) {
              Object.keys(this.props.tournament.infoFields || {}).forEach(
                (key) => {
                  let extraField = this.props.tournament.infoFields[key];
                  columns.push({
                    id:
                      key +
                      "i" +
                      (this.props.tournament.individualPlayers
                        ? languages.teams.playerLow
                        : languages.results.teamLow) +
                      "2",
                    label:
                      extraField.name +
                      " " +
                      (this.props.tournament.individualPlayers
                        ? languages.teams.playerLow
                        : languages.results.teamLow) +
                      " 2",
                  });
                }
              );
            }
            if (this.state.includePlayerNames) {
              for (let i = 0; i < numPlayerColumns; i++) {
                columns.push({
                  id:
                    languages.teams.player +
                    (i + 1).toString() +
                    (this.props.tournament.individualPlayers
                      ? languages.teams.playerLow
                      : languages.results.teamLow) +
                    "2",
                  label:
                    languages.teams.player +
                    " " +
                    (i + 1).toString() +
                    " " +
                    (this.props.tournament.individualPlayers
                      ? languages.teams.playerLow
                      : languages.results.teamLow) +
                    " 2",
                });
              }
            }
            if (showReferee1Col) {
              columns.push({
                id: "referee1Name",
                label: languages.referees.referee,
              });
            }
            if (showReferee2Col) {
              columns.push({
                id: "referee2Name",
                label: languages.referees.referee2,
              });
            }
            if (showReferee3Col) {
              columns.push({
                id: "referee3Name",
                label: languages.referees.referee3,
              });
            }
            if (showReferee4Col) {
              columns.push({
                id: "referee4Name",
                label: languages.referees.referee4,
              });
            }
            if (showReferee5Col) {
              columns.push({
                id: "referee5Name",
                label: languages.referees.referee5,
              });
            }

            let sheets = [];
            if (this.state.sort === "team") {
              let sheetNamesUsed = [];
              allTeams.forEach((t) => {
                let matches = matchesArray.filter(
                  (match) =>
                    match.team1Id === t.id ||
                    match.team2Id === t.id ||
                    match.referee === t.id ||
                    match.referee2 === t.id ||
                    match.referee3 === t.id ||
                    match.referee4 === t.id ||
                    match.referee5 === t.id ||
                    (match.teams || []).indexOf(t.id) !== -1
                );
                if (matches.length > 0) {
                  let sheetName = t.name || "";
                  let validSheetName = sheetNamesUsed.indexOf(sheetName) === -1;
                  let duplicateNum = 0;
                  while (!validSheetName) {
                    duplicateNum++;
                    sheetName =
                      sheetName + " (" + duplicateNum.toString() + ")";
                    validSheetName = sheetNamesUsed.indexOf(sheetName) === -1;
                  }
                  sheetNamesUsed.push(sheetName);
                  sheets.push({ name: sheetName, rows: matches });
                }
              });
            } else if (this.state.sort === "poule") {
              this.props.poules
                .filter((p) => !p.bracket)
                .concat(this.props.brackets)
                .sort((a, b) => {
                  if (a.indexNum > b.indexNum) {
                    return 1;
                  } else if (a.indexNum < b.indexNum) {
                    return -1;
                  } else {
                    return a.num - b.num;
                  }
                })
                .forEach((poule) => {
                  let matches = matchesArray.filter(
                    (match) =>
                      match.poule === poule.id || match.bracket === poule.id
                  );
                  if (matches.length > 0) {
                    sheets.push({ name: poule.name || "", rows: matches });
                  }
                });
            } else {
              sheets = [
                { name: languages.tournament.results, rows: matchesArray },
              ];
            }
            this.setState({
              exportExcel: true,
              preparingExcelExport: false,
              sheets: sheets,
              cols: columns,
            });
            this.toggleExportDialog();
          });
      });
  };

  handleMatchCardsExport = (e, amount) => {
    var doc = new jsPDF();
    doc.addFileToVFS("Roboto-Medium-normal.ttf", robotoMedium);
    doc.addFont("Roboto-Medium-normal.ttf", "Roboto-Medium", "normal");
    doc.addFileToVFS("Roboto-Bold-bold.ttf", robotoBold);
    doc.addFont("Roboto-Bold-bold.ttf", "Roboto-Bold", "bold");
    doc.setFont("Roboto-Medium", "normal", "normal");
    let matchesArray = [];

    let datauri =
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAZiS0dEAAAAAAAA+UO7fwAAAAlwSFlzAAAASAAAAEgARslrPgAAAc5JREFUWMPt18+LTWEcx/HXvWbBuGWslKZZKf4BmtxRFmKvppT9WMlSUZytYiELGysrJSVNKTSmxo+sNBtlQzRdkgZFJhSL85g5Tu517nOfg5r51FPP6fs93/P+/njO6bCmVaIM38PKUgZu/uvMqgLtSviMvmKVgTbgPB7hUAKYgyHWZbRiApy1MhuLGOvil/nzDI2FGD/9zsUAtfC0EGQO6yKAmrhb8HmJzVUAyi37iMP4Eq4ncDIisVPYG/bf5O1/V+XG32XfwRL2h+s9uI2Fgs8QXuE+ZvGsYNsYYB4E+0XcjEjqFzVwHZfQ7gK+OtSo6NfETuzAFnk77gXbhLyKg+hMVceWfEA7Vk5M+WRlJVvMWtZQD5hxXMPWAbPvS92ADsiHen0XexvHC/tatR3vDd6GZC27gE01J/0JD3EH070c2zVV4Kv8JXkau/WY3bJhMmEVOriBW5jBh5gg8wmrksUAlD+uowkrFKUy0HDC2EspgF4nBOqkAHqSEChJrCPSDPSC6h/unhrB2wRAJxJW2rEBYV5Iezg0cCUS5rO0/3TLGsbVPmEWsa8OmGKljqo2U9PYVidMUSOYCg99Ln/hvcFj+c/f+N8CWdN/qR+EMfux/5crcwAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMC0wMS0zMFQxMzo0OTozOCswMDowMFmNIVoAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjAtMDEtMzBUMTM6NDk6MzgrMDA6MDAo0JnmAAAAKHRFWHRzdmc6YmFzZS11cmkAZmlsZTovLy90bXAvbWFnaWNrLVpTTE81Q2JOLjFAnAAAAABJRU5ErkJggg==";
    let datauripsd =
      "data:image/png;base64,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";
    let isPSDUser = false;
    if ((this.props.userData || {}).isPSD) {
      isPSDUser = true;
    }

    let addEvents = false;
    if (
      this.state.includeEvents &&
      this.state.export === "schedule" &&
      this.state.sort !== "poule" &&
      this.state.sort !== "referee"
    ) {
      addEvents = true;
    }

    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    tournamentRef
      .collection("teams")
      .get()
      .then((querySnapshot) => {
        let allTeams = [];
        let teamsByKey = {};
        querySnapshot.forEach((doc) => {
          let team = doc.data();
          team["id"] = doc.id;
          allTeams.push(team);
          teamsByKey[doc.id] = team;
        });

        if (this.state.sort === "team") {
          // let teams = [];
          // let teamIdsUsed = [];
          Object.keys(
            this.props.tournament.online
              ? this.props.onlineRounds
              : this.props.matchesPerDay
          ).forEach((d) => {
            let matches = (
              this.props.tournament.online
                ? this.props.onlineRounds
                : this.props.matchesPerDay
            )[d];
            matches.forEach((m) => {
              if (this.props.tournament.online) {
                m["roundN"] = d;
              }
              const poule = this.props.poulesByKey[m.poule] || {};
              let pouleKeyName = poule.fase;
              if (poule.bracket) {
                let bracket = this.props.bracketsByKey[poule.bracket] || {};
                pouleKeyName =
                  poule.bracketRound === bracket.size && !bracket.subBracketTo
                    ? poule.fase
                    : poule.fase +
                      "-" +
                      poule.bracketRound +
                      "-" +
                      poule.bracket;
              }
              let team1 = allTeams.find((team) => {
                return (
                  team["poule" + pouleKeyName] === m.poule &&
                  team["numInPoule" + pouleKeyName] === m.team1
                );
              });
              let team2 = allTeams.find((team) => {
                return (
                  team["poule" + pouleKeyName] === m.poule &&
                  team["numInPoule" + pouleKeyName] === m.team2
                );
              });
              // if (team1 && teamIdsUsed.indexOf(team1.id) === -1) {
              //   teams.push(team1);
              //   teamIdsUsed.push(team1.id);
              // }
              if (team1 && !m.isEvent) {
                let matchCopy1 = { ...m };
                matchCopy1["forTeam"] = team1.id;
                matchesArray.push(matchCopy1);
              }
              // if (team2 && teamIdsUsed.indexOf(team2.id) === -1) {
              //   teams.push(team2);
              //   teamIdsUsed.push(team2.id);
              // }
              if (team2 && !m.isEvent) {
                let matchCopy2 = { ...m };
                matchCopy2["forTeam"] = team2.id;
                matchesArray.push(matchCopy2);
              }

              if (m.referee && teamsByKey[m.referee]) {
                let matchCopy = { ...m };
                matchCopy["forTeam"] = m.referee;
                matchesArray.push(matchCopy);
              }

              if (m.referee2 && teamsByKey[m.referee2]) {
                let matchCopy = { ...m };
                matchCopy["forTeam"] = m.referee2;
                matchesArray.push(matchCopy);
              }

              if (m.referee3 && teamsByKey[m.referee3]) {
                let matchCopy = { ...m };
                matchCopy["forTeam"] = m.referee3;
                matchesArray.push(matchCopy);
              }

              if (m.referee4 && teamsByKey[m.referee4]) {
                let matchCopy = { ...m };
                matchCopy["forTeam"] = m.referee4;
                matchesArray.push(matchCopy);
              }

              if (m.referee5 && teamsByKey[m.referee5]) {
                let matchCopy = { ...m };
                matchCopy["forTeam"] = m.referee5;
                matchesArray.push(matchCopy);
              }

              if (m.isEvent && addEvents) {
                m.teams.forEach((teamId) => {
                  let team = teamsByKey[teamId];
                  if (team) {
                    let matchCopy = { ...m };
                    matchCopy["forTeam"] = team.id;
                    matchesArray.push(matchCopy);
                  }
                });
              }
            });
          });
        } else if (this.state.sort === "referee") {
          Object.keys(this.props.matchesPerDay).forEach((d) => {
            let matches = this.props.matchesPerDay[d];
            matches.forEach((m) => {
              if (m.referee) {
                let matchCopy1 = { ...m };
                matchCopy1["forReferee"] = m.referee;
                matchesArray.push(matchCopy1);
              }
              if (m.referee2) {
                let matchCopy2 = { ...m };
                matchCopy2["forReferee"] = m.referee2;
                matchesArray.push(matchCopy2);
              }
            });
          });
        } else {
          Object.keys(
            this.props.tournament.online
              ? this.props.onlineRounds
              : this.props.matchesPerDay
          ).forEach((d) => {
            let matches = (
              this.props.tournament.online
                ? this.props.onlineRounds
                : this.props.matchesPerDay
            )[d];
            matches.forEach((m) => {
              if (this.props.tournament.online) {
                m["roundN"] = d;
              }
              if (m.isEvent) {
                if (addEvents) {
                  matchesArray.push(m);
                }
              } else {
                matchesArray.push(m);
              }
            });
          });
        }
        if (!this.props.tournament.online) {
          matchesArray = matchesArray.filter(
            (m) => m.day === "0" || this.props.daysByKey[m.day]
          );
        }
        matchesArray.sort((a, b) => {
          let dateA =
            a.day === "0"
              ? this.props.tournament.date
              : this.props.daysByKey[a.day].date;
          let dateB =
            b.day === "0"
              ? this.props.tournament.date
              : this.props.daysByKey[b.day].date;
          if (this.state.sort === "poule") {
            let pouleA = this.props.poulesByKey[a.poule] || {};
            let pouleB = this.props.poulesByKey[b.poule] || {};
            if (pouleA.bracket) {
              pouleA = this.props.bracketsByKey[pouleA.bracket];
            }
            if (pouleB.bracket) {
              pouleB = this.props.bracketsByKey[pouleB.bracket];
            }
            if (Number(pouleA.division) > Number(pouleB.division)) {
              return 1;
            } else if (Number(pouleA.division) < Number(pouleB.division)) {
              return -1;
            } else if (pouleA.indexNum > pouleB.indexNum) {
              return 1;
            } else if (pouleA.indexNum < pouleB.indexNum) {
              return -1;
            } else if (Number(pouleA.num) > Number(pouleB.num)) {
              return 1;
            } else if (Number(pouleA.num) < Number(pouleB.num)) {
              return -1;
            }
          }
          if (this.state.sort === "team") {
            if (a.forTeam > b.forTeam) {
              return 1;
            } else if (a.forTeam < b.forTeam) {
              return -1;
            }
          }

          if (this.state.sort === "referee") {
            if (a.forReferee > b.forReferee) {
              return 1;
            } else if (a.forReferee < b.forReferee) {
              return -1;
            }
          }

          let fields = this.props.tournament.fields || {};
          let fieldA = fields[a.field] || {};
          let fieldB = fields[b.field] || {};

          if (dateA > dateB) {
            return 1;
          } else if (dateA < dateB) {
            return -1;
          } else if (
            moment(a.startTime, "HH:mm").unix() >
            moment(b.startTime, "HH:mm").unix()
          ) {
            return 1;
          } else if (
            moment(a.startTime, "HH:mm").unix() <
            moment(b.startTime, "HH:mm").unix()
          ) {
            return -1;
          } else if (fieldA.num > fieldB.num) {
            return 1;
          } else if (fieldA.num < fieldB.num) {
            return -1;
          } else if (Number(a.field) > Number(b.field)) {
            return 1;
          } else if (Number(a.field) < Number(b.field)) {
            return -1;
          } else {
            return 0;
          }
        });
        if (!this.props.tournament.online) {
          if (this.state.sort === "field") {
            let fields = this.props.tournament.fields || {};

            matchesArray.sort((a, b) => {
              let dateA =
                a.day === "0"
                  ? this.props.tournament.date
                  : this.props.daysByKey[a.day].date;
              let dateB =
                b.day === "0"
                  ? this.props.tournament.date
                  : this.props.daysByKey[b.day].date;

              let fieldA = fields[a.field] || {};
              let fieldB = fields[b.field] || {};

              if (dateA > dateB) {
                return 1;
              } else if (dateA < dateB) {
                return -1;
              } else if (fieldA.num > fieldB.num) {
                return 1;
              } else if (fieldA.num < fieldB.num) {
                return -1;
              } else if (Number(a.field) > Number(b.field)) {
                return 1;
              } else if (Number(a.field) < Number(b.field)) {
                return -1;
              } else if (
                moment(a.startTime, "HH:mm").unix() >
                moment(b.startTime, "HH:mm").unix()
              ) {
                return 1;
              } else if (
                moment(a.startTime, "HH:mm").unix() <
                moment(b.startTime, "HH:mm").unix()
              ) {
                return -1;
              } else {
                return 0;
              }
            });
          }
        }
        matchesArray = matchesArray.filter((match) => {
          let division =
            (this.props.poulesByKey[match.poule] || {}).division || "";
          let fase =
            (this.props.poulesByKey[match.poule] || {}).fase !== undefined
              ? (this.props.poulesByKey[match.poule] || {}).fase
              : "";

          let fields = this.props.tournament.fields || {};
          let field = fields[match.field] || {};
          let sportPark = field.sportPark || "0";

          if (
            ((this.state.fases[division] || []).indexOf(fase.toString()) !==
              -1 ||
              (match.isEvent && addEvents)) &&
            (sportPark === this.state.selectedLocation ||
              this.state.selectedLocation === "all") &&
            (match.day === this.state.selectedDay ||
              this.state.selectedDay === "all")
          ) {
            return true;
          } else {
            return false;
          }
        });
        let lastPoule = "";
        let lastDay = "";
        let rowNum = 0;
        let numPerPage = 40;
        matchesArray.forEach((m, i) => {
          let fieldString =
            ((this.props.tournament.fields || {})[m.field] || {}).name || "";

          if (
            this.state.export === "schedule" &&
            this.state.selectedLocation === "all" &&
            this.props.sportParks.length > 1
          ) {
            let fields = this.props.tournament.fields || {};
            let field = fields[m.field] || {};
            let sportPark = field.sportPark || "0";
            fieldString +=
              " - " + (this.props.sportParksByKey[sportPark] || {}).name || "";
          }

          let timeString = m.startTime + " - " + m.endTime;
          let dayString =
            Object.keys(this.props.matchesPerDay).length > 1
              ? m.day === "0"
                ? moment
                    .unix(this.props.tournament.date)
                    .format(languages.createTournament.dateFormat)
                : moment
                    .unix(this.props.daysByKey[m.day].date)
                    .format(languages.createTournament.dateFormat)
              : "";
          if (this.props.tournament.online) {
            let roundTime =
              (this.props.tournament.roundTimes || {})[Number(m.roundN)] || {};
            let time = roundTime["time"] || "";

            let day = roundTime["day"] || "0";
            let roundDate =
              day === "0"
                ? this.props.tournament.date
                : (this.props.daysByKey[day] || {}).date || "";
            if (roundDate) {
              roundDate = moment
                .unix(roundDate)
                .format(languages.createTournament.dateFormat);
            }
            if (Object.keys(this.props.daysByKey).length === 0) {
              roundDate = "";
            }
            dayString =
              languages.schedule.round +
              " " +
              (Number(m.roundN) + 1).toString() +
              ": " +
              time +
              (time && roundDate ? ", " : "") +
              roundDate;
            timeString = "";
          }
          const refereeString =
            ((this.props.refereesByKey[m.referee] || {}).name || "") +
            (m.referee2
              ? " & " + (this.props.refereesByKey[m.referee2] || {}).name
              : "") +
            (m.referee3
              ? " & " + (this.props.refereesByKey[m.referee3] || {}).name
              : "") +
            (m.referee4
              ? " & " + (this.props.refereesByKey[m.referee4] || {}).name
              : "") +
            (m.referee5
              ? " & " + (this.props.refereesByKey[m.referee5] || {}).name
              : "");

          const poule = this.props.poulesByKey[m.poule] || {};
          let scoreType =
            poule.scoreType ||
            (poule.bracket
              ? (this.props.bracketsByKey[poule.bracket] || {})["scoreType"]
              : false) ||
            ((this.props.tournament.scoringTypesPerDivisionPerPhase || {})[
              poule.division
            ] || {})[poule.fase] ||
            "default";
          let scoring =
            scoreType === "default"
              ? this.props.tournament
              : (this.props.tournament.scoringTypes || {})[scoreType] ||
                this.props.tournament;

          const useSets = (scoring.useSets || "0") === "1";
          const setsType = scoring.setsType || 0;

          let pouleString = poule.name || "";
          const divisionString =
            (this.props.divisionsObject[poule.division] || {}).name || "";
          const fase = poule.fase;
          const faseString =
            (
              ((this.props.divisionsObject[poule.division] || {}).fases || {})[
                fase
              ] || {}
            ).name ||
            (defaultFases[fase] || {}).name ||
            "";

          pouleString = pouleString + " - " + faseString;
          if (
            Object.keys(this.props.divisionsObject).length > 1 &&
            this.state.export === "schedule"
          ) {
            pouleString += " - " + divisionString;
          }
          if (m.isEvent) {
            let teamStrings = [];
            m.teams.forEach((t) => {
              let teamObject = teamsByKey[t];
              if (teamObject) {
                teamStrings.push(teamObject.name || "");
              }
            });
            pouleString = teamStrings.join(", ");
            if (m.teams.length > 3) {
              pouleString =
                m.teams.length.toString() +
                " " +
                (this.props.tournament.individualPlayers
                  ? languages.teams.playersLow
                  : languages.tournament.teamsLow);
            }
          }
          let pouleKeyName = poule.fase;
          if (poule.bracket) {
            let bracket = this.props.bracketsByKey[poule.bracket] || {};
            pouleKeyName =
              poule.bracketRound === bracket.size && !bracket.subBracketTo
                ? poule.fase
                : poule.fase + "-" + poule.bracketRound + "-" + poule.bracket;
          }
          let team1String =
            (
              allTeams.find(
                (t) =>
                  t["poule" + pouleKeyName] === m.poule &&
                  t["numInPoule" + pouleKeyName] === m.team1
              ) || {}
            ).name || undefined;
          let team2String =
            (
              allTeams.find(
                (t) =>
                  t["poule" + pouleKeyName] === m.poule &&
                  t["numInPoule" + pouleKeyName] === m.team2
              ) || {}
            ).name || undefined;
          if (team1String === undefined) {
            team1String =
              this.props.resultSpots.filter(
                (resultSpot) =>
                  resultSpot["poule" + poule.fase] === m.poule &&
                  resultSpot["numInPoule" + poule.fase] === m.team1
              )[0] || "";
            if (team1String !== "") {
              team1String = getResultSpotName(
                team1String,
                this.props.resultSpots,
                this.props.poulesByKey,
                this.props.divisionsObject
              );
            }
          }
          if (team2String === undefined) {
            team2String =
              this.props.resultSpots.filter(
                (resultSpot) =>
                  resultSpot["poule" + poule.fase] === m.poule &&
                  resultSpot["numInPoule" + poule.fase] === m.team2
              )[0] || "";
            if (team2String !== "") {
              team2String = getResultSpotName(
                team2String,
                this.props.resultSpots,
                this.props.poulesByKey,
                this.props.divisionsObject
              );
            }
          }
          if (m.isEvent) {
            team1String = "";
            team2String = "";
          }
          if (team1String === "") {
            if (m.isEvent) {
              team1String = m.name || "";
            } else {
              team1String =
                languages.structure.emptySpot +
                " " +
                (Number(m.team1) + 1).toString();
            }
          }

          if (team2String === "") {
            if (m.isEvent) {
              team2String = m.name || "";
            } else {
              team2String =
                languages.structure.emptySpot +
                " " +
                (Number(m.team2) + 1).toString();
            }
          }
          // console.log(
          //   fieldString,
          //   timeString,
          //   dayString,
          //   pouleString,
          //   divisionString,
          //   refereeString,
          //   team1String,
          //   team2String
          // );

          if (this.state.export === "cards") {
            if (this.state.format === "multiple") {
              if (i !== 0 && i % 6 === 0) {
                doc.addPage();
              }

              let extraY = 0;
              if (dayString) {
                extraY = 5;
                doc.setFontSize(11);
                doc.text(
                  dayString,
                  (i % 2) * 105 + 5,
                  (((i % 6) - ((i % 6) % 2)) / 2) * 99 + 10
                );
              }
              doc.setFontSize(12);
              // doc.setFontStyle("bold");
              doc.setFont("Roboto-Bold", "bold", "bold");
              doc.text(
                fieldString,
                (i % 2) * 105 + 5,
                (((i % 6) - ((i % 6) % 2)) / 2) * 99 + 10 + extraY
              );

              if (isPSDUser) {
                doc.addImage(
                  datauripsd,
                  "PNG",
                  (i % 2) * 105 + 5 + 80,
                  (((i % 6) - ((i % 6) % 2)) / 2) * 99 + 13 + extraY,
                  15,
                  15
                );
              }
              doc.text(
                timeString,
                (i % 2) * 105 + 5 + 69,
                (((i % 6) - ((i % 6) % 2)) / 2) * 99 + 10 + extraY
              );
              // doc.setFontStyle("normal");
              doc.setFont("Roboto-Medium", "normal", "normal");
              doc.setFontSize(11);
              doc.text(
                pouleString,
                (i % 2) * 105 + 5,
                (((i % 6) - ((i % 6) % 2)) / 2) * 99 + 18 + extraY
              );
              if (Object.keys(this.props.divisionsObject).length > 1) {
                doc.text(
                  divisionString,
                  (i % 2) * 105 + 5,
                  (((i % 6) - ((i % 6) % 2)) / 2) * 99 + 22 + extraY
                );
              }
              if (refereeString) {
                doc.addImage(
                  datauri,
                  "PNG",
                  (i % 2) * 105 + 5,
                  (((i % 6) - ((i % 6) % 2)) / 2) * 99 + 26 + extraY,
                  4,
                  4
                );
                doc.text(
                  refereeString,
                  (i % 2) * 105 + 10,
                  (((i % 6) - ((i % 6) % 2)) / 2) * 99 + 30 + extraY
                );
                extraY += 5;
              }
              doc.text(
                doc.splitTextToSize(team1String, 43),
                (i % 2) * 105 + 5,
                (((i % 6) - ((i % 6) % 2)) / 2) * 99 + 35 + extraY
              );
              doc.text(
                doc.splitTextToSize(team2String, 43),
                (i % 2) * 105 + 5 + 52,
                (((i % 6) - ((i % 6) % 2)) / 2) * 99 + 35 + extraY
              );
              doc.setLineWidth(0.1);
              doc.setDrawColor(171, 171, 171);
              doc.line(
                (i % 2) * 105 + 5 + 45,
                (((i % 6) - ((i % 6) % 2)) / 2) * 99 + 30 + extraY,
                (i % 2) * 105 + 5 + 45,
                (((i % 6) - ((i % 6) % 2)) / 2) * 99 + 80 + extraY
              );
              doc.line(
                (i % 2) * 105 + 5,
                (((i % 6) - ((i % 6) % 2)) / 2) * 99 + 30 + extraY,
                (i % 2) * 105 + 5 + 95,
                (((i % 6) - ((i % 6) % 2)) / 2) * 99 + 30 + extraY
              );
              Object.keys(this.props.tournament.customPoints || {})
                .slice(0, 4)
                .forEach((key, index) => {
                  let customPoints = this.props.tournament.customPoints[key];
                  doc.setFontSize(9);
                  doc.text(
                    customPoints.abbr || "",
                    (i % 2) * 105 + 6 + index * 11,
                    (((i % 6) - ((i % 6) % 2)) / 2) * 99 + 74 + extraY
                  );
                  doc.rect(
                    (i % 2) * 105 + 6 + index * 11,
                    (((i % 6) - ((i % 6) % 2)) / 2) * 99 + 75 + extraY,
                    10,
                    5
                  );
                  doc.text(
                    customPoints.abbr || "",
                    (i % 2) * 105 + 6 + index * 11 + 45,
                    (((i % 6) - ((i % 6) % 2)) / 2) * 99 + 74 + extraY
                  );
                  doc.rect(
                    (i % 2) * 105 + 6 + index * 11 + 45,
                    (((i % 6) - ((i % 6) % 2)) / 2) * 99 + 75 + extraY,
                    10,
                    5
                  );
                });
            } else if (this.state.format === "single") {
              if (i !== 0) {
                doc.addPage();
              }

              let extraY = 0;
              if (dayString) {
                extraY = 6;
                doc.setFontSize(13);
                doc.text(dayString, 5, 10);
              }
              doc.setFontSize(14);
              // doc.setFontStyle("bold");
              doc.setFont("Roboto-Bold", "bold", "bold");
              doc.text(fieldString, 5, 10 + extraY);
              doc.text(timeString, 5 + 69 + 101, 10 + extraY);
              if (isPSDUser) {
                doc.addImage(
                  datauripsd,
                  "PNG",
                  5 + 69 + 116,
                  13 + extraY,
                  15,
                  15
                );
              }
              // doc.setFontStyle("normal");
              doc.setFont("Roboto-Medium", "normal", "normal");
              doc.setFontSize(13);
              doc.text(pouleString, 5, 18 + extraY);
              if (Object.keys(this.props.divisionsObject).length > 1) {
                doc.text(divisionString, 5, 23 + extraY);
              }
              if (refereeString) {
                doc.addImage(datauri, "PNG", 5, 27 + extraY, 4, 4);
                doc.text(refereeString, 10, 31 + extraY);
                extraY += 6;
              }
              doc.text(doc.splitTextToSize(team1String, 80), 5, 35 + extraY);
              doc.text(
                doc.splitTextToSize(team2String, 80),
                52 + 52,
                35 + extraY
              );
              doc.setLineWidth(0.1);
              doc.setDrawColor(171, 171, 171);
              doc.line(5 + 45 + 52, 30 + extraY, 5 + 45 + 52, 260 + extraY);
              doc.line(5, 30 + extraY, 5 + 95 + 105, 30 + extraY);
              Object.keys(this.props.tournament.customPoints || {})
                .slice(0, 6)
                .forEach((key, index) => {
                  let customPoints = this.props.tournament.customPoints[key];
                  doc.setFontSize(9);
                  doc.text(
                    customPoints.abbr || "",
                    6 + index * 16,
                    252 + extraY
                  );
                  doc.rect(6 + index * 16, 253 + extraY, 15, 7);
                  doc.text(
                    customPoints.abbr || "",
                    6 + index * 16 + 45 + 52,
                    252 + extraY
                  );
                  doc.rect(6 + index * 16 + 45 + 52, 253 + extraY, 15, 7);
                });
            }
          } else if (this.state.export === "schedule") {
            // let rowNum = (i + extraRows) % numPerPage;
            // if (this.state.sort === "poule" || this.state.sort === "team") {
            //   rowNum = extraRows;
            //   extraRows += 1;
            // }
            if (i === 0) {
              if (isPSDUser) {
                doc.addImage(datauripsd, "PNG", 5 + 69 + 120, 3, 12, 12);
              }
            }
            let whiteSpaceTop = 12;
            if (isPSDUser) {
              whiteSpaceTop = 18;
            }
            let pouleKey = this.state.sort === "team" ? m.forTeam : m.poule;
            let poule =
              this.state.sort === "team"
                ? teamsByKey[m.forTeam] || {}
                : this.props.poulesByKey[m.poule] || {};
            if (poule.bracket) {
              pouleKey = poule.bracket;
              poule = this.props.bracketsByKey[pouleKey] || {};
            }
            if (
              pouleKey !== lastPoule &&
              (this.state.sort === "poule" || this.state.sort === "team")
            ) {
              lastPoule = pouleKey;
              lastDay = "";
              // extraRows = 0;
              if (i !== 0) {
                doc.addPage();
                rowNum = 0;
                if (isPSDUser) {
                  doc.addImage(datauripsd, "PNG", 5 + 69 + 120, 3, 12, 12);
                }
              }
              doc.setFontSize(8);
              let pouleName = poule.name || "";
              if (
                Object.keys(this.props.divisionsObject).length > 1 &&
                !this.state.sort === "team"
              ) {
                pouleName += " - " + divisionString;
              }
              doc.text(pouleName, 5, rowNum * 7 + whiteSpaceTop);
              // extraRows += 1;
              // rowNum = (i + extraRows) % numPerPage;
              rowNum++;
              // extraRows += 1;
            }

            if (i !== 0 && rowNum >= numPerPage) {
              doc.addPage();
              // extraRows = 0;
              rowNum = 0;
              if (isPSDUser) {
                doc.addImage(datauripsd, "PNG", 5 + 69 + 120, 3, 12, 12);
              }
            }

            if (
              this.state.selectedDay === "all" &&
              Object.keys(this.props.daysByKey).length > 0 &&
              lastDay !== (this.props.tournament.online ? m.roundN : m.day)
            ) {
              lastDay = this.props.tournament.online ? m.roundN : m.day;
              doc.setFont("Roboto-Bold", "bold", "bold");
              doc.setFontSize(6);
              doc.text(dayString, 5, rowNum * 7 + whiteSpaceTop);
              doc.setFont("Roboto-Medium", "normal", "normal");
              // extraRows += 1;
              // rowNum = (i + extraRows) % numPerPage;
              rowNum++;
              if (i !== 0 && rowNum >= numPerPage) {
                doc.addPage();
                rowNum = 0;
                if (isPSDUser) {
                  doc.addImage(datauripsd, "PNG", 5 + 69 + 120, 3, 12, 12);
                }
              }
            }
            doc.setFontSize(6);
            doc.text(timeString, 5, rowNum * 7 + whiteSpaceTop);
            doc.text(
              doc.splitTextToSize(fieldString, 28),
              22,
              rowNum * 7 + whiteSpaceTop
            );

            doc.text(
              doc.splitTextToSize(team1String, 28),
              75 + 5,
              rowNum * 7 + whiteSpaceTop,
              { align: "right" }
            );
            doc.rect(76 + 5, rowNum * 7 + whiteSpaceTop - 3, 15, 5);
            doc.rect(92 + 5, rowNum * 7 + whiteSpaceTop - 3, 15, 5);

            if (this.state.includeResults) {
              let result1String = "";
              let result2String = "";
              let showPenaltiesInMatchButton = false;
              let score1PenaltyAsterisk = "";
              let score2PenaltyAsterisk = "";

              if (m.score1 !== null && m.score2 !== null && !useSets) {
                if (m.score1 > m.score2) {
                  score1PenaltyAsterisk = "*";
                } else if (m.score1 < m.score2) {
                  score2PenaltyAsterisk = "*";
                } else {
                  if (m.winner === m.team1) {
                    score1PenaltyAsterisk = "*";
                  } else if (m.winner === m.team2) {
                    score2PenaltyAsterisk = "*";
                  }
                  if (
                    scoring.enterPenaltyScores &&
                    m.penalties1 !== null &&
                    m.penalties1 !== undefined &&
                    m.penalties2 !== null &&
                    m.penalties2 !== undefined
                  ) {
                    showPenaltiesInMatchButton = true;
                  }
                }
              }

              if (!useSets) {
                result1String =
                  m.score1 !== null && m.score1 !== undefined
                    ? m.score1 +
                      (showPenaltiesInMatchButton
                        ? "(" + m.penalties1.toString() + ")"
                        : score1PenaltyAsterisk)
                    : "";
                result2String =
                  m.score2 !== null && m.score2 !== undefined
                    ? m.score2 +
                      (showPenaltiesInMatchButton
                        ? "(" + m.penalties2.toString() + ")"
                        : score2PenaltyAsterisk)
                    : "";
              } else {
                let pouleForMatch = this.props.poulesByKey[m.poule] || {};
                let scoreType =
                  pouleForMatch.scoreType ||
                  (pouleForMatch.bracket
                    ? (this.props.bracketsByKey[pouleForMatch.bracket] || {})[
                        "scoreType"
                      ]
                    : false) ||
                  ((this.props.tournament.scoringTypesPerDivisionPerPhase ||
                    {})[pouleForMatch.division] || {})[pouleForMatch.fase] ||
                  "default";
                let scoring =
                  scoreType === "default"
                    ? this.props.tournament
                    : (this.props.tournament.scoringTypes || {})[scoreType] ||
                      this.props.tournament;
                let gameResults = getGameResults(scoring, m.sets || {});
                if (gameResults.finished) {
                  if (setsType === 0) {
                    if (gameResults.result1 !== null) {
                      result1String = gameResults.result1;
                    }
                    if (gameResults.result2 !== null) {
                      result2String = gameResults.result2;
                    }
                  }
                }
              }
              doc.text(
                result1String.toString(),
                83 + 5,
                rowNum * 7 + whiteSpaceTop
              );
              doc.text(
                result2String.toString(),
                99 + 5,
                rowNum * 7 + whiteSpaceTop
              );
            }

            doc.text(
              doc.splitTextToSize(team2String, 28),
              108 + 5,
              rowNum * 7 + whiteSpaceTop
            );

            let splittedPouleString = doc.splitTextToSize(
              pouleString,
              refereeString ? 25 : 50
            );
            let negativeMarginTop = 0;
            if (splittedPouleString.length > 2) {
              negativeMarginTop = 2;
            }
            if (splittedPouleString.length === 2) {
              negativeMarginTop = 1;
            }
            doc.text(
              splittedPouleString.slice(0, 3),
              137 + 5,
              rowNum * 7 + whiteSpaceTop - negativeMarginTop
            );
            if (refereeString) {
              doc.addImage(
                datauri,
                "PNG",
                166 + 5,
                rowNum * 7 + whiteSpaceTop - 2,
                3,
                3
              );
              doc.text(
                doc.splitTextToSize(refereeString, 25),
                170 + 5,
                rowNum * 7 + whiteSpaceTop
              );
            }
            doc.line(
              5,
              rowNum * 7 + whiteSpaceTop + 3,
              5 + 200,
              rowNum * 7 + whiteSpaceTop + 3
            );
            rowNum++;
          }
        });

        const fileName =
          this.state.export === "cards"
            ? `${languages.export.matchCards} - ${this.props.tournament.name}`
            : `${languages.export.matchSchedule} - ${this.props.tournament.name}`;

        doc.save(`${fileName}.pdf`);
        this.toggleExportDialog();
      });
  };

  render() {
    let atLeastOnePhaseSelected = false;
    Object.keys(this.state.fases).forEach((key) => {
      const division = this.state.fases[key];
      if (division.length > 0) {
        atLeastOnePhaseSelected = true;
      }
    });

    return (
      <div>
        {/* <ExportScheduleDialog
          open={this.state.exportScheduleOpen}
          handleClose={this.toggleExportScheduleDialog}
        /> */}
        <ExportDialog
          open={this.state.exportDialogOpen}
          handleClose={
            this.state.export === "schedule"
              ? this.toggleExportScheduleDialog
              : this.toggleExportDialog
          }
          format={this.state.format}
          sort={this.state.sort}
          handleSortChange={this.handleSortChange}
          handleFormatChange={this.handleFormatChange}
          matchesPerDay={this.props.matchesPerDay}
          // handleSelectChange={this.handleSelectChange}
          // days={this.state.days}
          // divisions={this.state.divisions}
          fases={this.state.fases}
          handleFasesChange={this.handleFasesChange}
          tournament={this.props.tournament}
          daysByKey={this.props.daysByKey}
          divisionsObject={this.props.divisionsObject}
          handleMatchCardsExport={this.handleMatchCardsExport}
          handleExcelExport={this.handleExcelExport}
          sportParks={this.props.sportParks}
          sportParksByKey={this.props.sportParksByKey}
          selectedLocation={this.state.selectedLocation}
          selectedDay={this.state.selectedDay}
          handleLocationChange={this.handleLocationChange}
          matches={this.props.matches}
          poules={this.props.poules}
          export={this.state.export}
          handleIncludeEventsChange={this.handleIncludeEventsChange}
          handleIncludePlayerNamesChange={this.handleIncludePlayerNamesChange}
          handleIncludeResultsChange={this.handleIncludeResultsChange}
          handleFileTypeChange={this.handleFileTypeChange}
          includeEvents={this.state.includeEvents}
          fileType={this.state.fileType}
          includePlayerNames={this.state.includePlayerNames}
          includeResults={this.state.includeResults}
          handleIncludeCustomFieldsChange={this.handleIncludeCustomFieldsChange}
          includeCustomFields={this.state.includeCustomFields}
          players={this.props.players}
          preparingExcelExport={this.state.preparingExcelExport}
          poulesByKey={this.props.poulesByKey}
          bracketsByKey={this.props.bracketsByKey}
          atLeastOnePhaseSelected={atLeastOnePhaseSelected}
          selectAllPhases={this.selectAllPhases}
        />
        <Menu
          id="menu-export"
          anchorEl={this.state.anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          getContentAnchorEl={null}
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleClose}
          style={{ zIndex: 1302 }}
        >
          <MenuItem onClick={this.toggleExportScheduleDialog}>
            {languages.export.matchSchedule}
          </MenuItem>
          {!this.props.tournament.online && (
            <MenuItem onClick={this.toggleExportDialog}>
              {languages.export.matchCards}
            </MenuItem>
          )}
        </Menu>
        <Button
          size="small"
          variant="outlined"
          color="default"
          onClick={this.handleMenu}
          className={
            this.props.schedulePage
              ? this.props.classes.buttonSchedule
              : this.props.classes.button
          }
          style={{ minWidth: 120 }}
        >
          {languages.export.export}
          <DownloadIcon style={{ height: 16, width: 16, marginLeft: 3 }} />
        </Button>
        {this.props.schedulePage && (
          <div className={this.props.classes.iconButton} style={{ padding: 2 }}>
            <IconButton
              onClick={this.handleMenu}
              style={{ height: 28, width: 28, marginRight: 4 }}
            >
              <DownloadIcon
                style={{ height: 20, width: 20, position: "absolute", top: 4 }}
              />
            </IconButton>
          </div>
        )}
        {this.state.exportExcel && (
          <ExcelFile
            hideElement
            filename={`${languages.export.matchSchedule} - ${this.props.tournament.name}`}
          >
            {this.state.sheets.map((sheet, i) => {
              return (
                <ExcelSheet key={i} data={sheet.rows} name={sheet.name}>
                  {this.state.cols.map((column) => {
                    let label = column.label;
                    return (
                      <ExcelColumn
                        key={column.id}
                        label={label}
                        value={column.id}
                      />
                    );
                  })}
                </ExcelSheet>
              );
            })}
          </ExcelFile>
        )}
      </div>
    );
  }
}

ExportContainer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(ExportContainer);
